const escrowWalletFR = {
    "view": {
        "title": "Gérez Votre Portefeuille Séquestre",
        "descriptionParagraph1": "Les fonds sont retenus pour garantir la sécurité et la transparence pendant le processus de vérification. Pour les pistes signalées, des frais de <strong>15 €</strong> par piste sont retenus en séquestre pour mettre la piste sur liste blanche pour la livraison à Spotify. Ces fonds seront remboursés une fois que les artistes de la piste seront vérifiés comme légitimes.",
        "descriptionParagraph2": "Utilisez le tableau ci-dessous pour voir toutes les transactions de séquestre. Pour plus de détails, <1><strong>En savoir plus</strong></1>",
        "label": {
            "totalWithheld": "Total Retenu",
            "totalRefunds": "Total des Remboursements"
        },
        "escrowPayments": {
            "title": "Paiements en Séquestre",
            "table": {
                "column": {
                    "paymentId": "ID de Paiement",
                    "releaseName": "Sortie",
                    "amount": "Montant",
                    "paymentDate": "Date de Paiement",
                    "paymentAgreement": "Accord de Paiement",
                    "refundProcessed": "Remboursement Traité",
                    "requestRefund": "Demander un Remboursement",
                    "details": "Détails"
                },
                "placeholder": {
                    "search": "Rechercher..."
                },
                "button": {
                    "download": "Télécharger",
                    "exportCsv": "Exporter CSV",
                    "view": "Voir",
                    "requestRefund": "Demander un Remboursement"
                },
                "label": {
                    "notAvailable": "Non Disponible"
                },
                "modal": {
                    "requestRefund": {
                        "header": "Demander un Remboursement",
                        "body": {
                            "description": "Êtes-vous sûr de vouloir demander un remboursement pour ce paiement ?",
                            "note": "Veuillez noter que cette demande est soumise à l'examen de l'administrateur et, si elle est approuvée, sera ajoutée comme déclaration pour laquelle vous pouvez émettre une facture."
                        },
                        "button": {
                            "confirm": "Confirmer",
                            "cancel": "Annuler"
                        },
                        "message": {
                            "success": "Demande de remboursement soumise avec succès !",
                            "error": "Quelque chose s'est mal passé, veuillez réessayer plus tard !"
                        }
                    }
                }
            }
        },
        "escrowPaymentBreakdown": {
            "title": "Répartition des Paiements en Séquestre",
            "table": {
                "column": {
                    "paymentId": "ID de Paiement",
                    "trackName": "Piste",
                    "amount": "Montant",
                    "paymentDate": "Date de Paiement"
                }
            }
        },
        "escrowRefunds": {
            "title": "Remboursements en Séquestre",
            "table": {
                "column": {
                    "refundId": "ID de Remboursement",
                    "paymentId": "ID de Paiement",
                    "release": "Sortie",
                    "amount": "Montant",
                    "requestDate": "Date de Demande",
                    "status": "Statut"
                },
                "label": {
                    "pending": "En Attente",
                    "approved": "Approuvé",
                    "rejected": "Rejeté"
                },
                "tooltip": {
                    "pending": "Votre demande de remboursement est actuellement en attente de révision par l'administrateur et sera traitée bientôt.",
                    "approved": "Votre demande de remboursement a été approuvée et une déclaration a été ajoutée pour le montant du remboursement.",
                    "rejected": "Votre demande de remboursement a été rejetée par l'administrateur, vous pouvez demander un remboursement à nouveau."
                },
                "placeholder": {
                    "search": "Rechercher..."
                },
                "button": {
                    "exportCsv": "Exporter CSV"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaction Réussie :)",
            "description": "Le paiement en séquestre a été effectué avec succès, la sortie pertinente sera mise sur liste blanche sous peu !",
            "button": {
                "returnToDashboard": "Retour au Tableau de Bord"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaction Annulée :(",
            "description": "La transaction a été annulée... Veuillez réessayer plus tard !",
            "button": {
                "returnToDashboard": "Retour au Tableau de Bord"
            }
        }
    }
};

export default escrowWalletFR;